import {
  PLYWOOD_PRODUCTION_DONE_FAILED,
  PLYWOOD_PRODUCTION_DONE_REQUEST,
  PLYWOOD_PRODUCTION_DONE_SUCCESS,
} from "../../../../actions/Factory/PlywoodProduction/plywoodProductionDone/constant";

const INIT_STATE = {
  loading: false,
  totalPage: 0,
  data: [],
  error: {
    isError: false,
    message: null,
  },
};

export const plywoodProductionDoneReducer = function (state = INIT_STATE, action) {
  switch (action?.type) {
    case PLYWOOD_PRODUCTION_DONE_REQUEST:
      return {
        loading: true,
        totalPage: 0,
        data: [],
        error: {
          isError: false,
          message: null,
        },
      };
    case PLYWOOD_PRODUCTION_DONE_SUCCESS:
      return {
        loading: false,
        data: action?.payload?.data,
        totalPage: action?.payload?.totalPage,
        error: {
          isError: false,
          message: null,
        },
      };
    case PLYWOOD_PRODUCTION_DONE_FAILED:
      const { isError = true, message = "Something Went Wrong" } =
        action?.payload?.error || {};
      return {
        loading: false,
        totalPage: 0,
        data: [],
        error: {
          isError: isError,
          message: message,
        },
      };
    default:
      return state;
  }
};
